import { Button, Container, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../auth/useAuthContext";
import Iconify from "../components/iconify";
import { useSettingsContext } from "../components/settings";
import { PATH_AUTH } from "../routes/paths";

export default function LandingPage() {
  const { logout } = useAuthContext();

  const { enqueueSnackbar } = useSnackbar();

  const navigate = useNavigate();

  const { themeStretch } = useSettingsContext();

  const handleLogout = async () => {
    try {
      logout();
      navigate(PATH_AUTH.login, { replace: true });
    } catch (error) {
      enqueueSnackbar("Unable to logout!", { variant: "error" });
    }
  };

  return (
    <>
      <Helmet>
        <title> Home | NKL Dashboard</title>
      </Helmet>

      <Container maxWidth={themeStretch ? false : "xl"}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h4">Dashboard</Typography>
          <Button
            variant="contained"
            onClick={handleLogout}
            style={{ cursor: "pointer", zIndex: "2000", position: "relative" }}
            startIcon={<Iconify icon="eva:log-out-outline" />}
          >
            Logout
          </Button>
        </div>
        <hr />

        {/* Original Dashboard Grid Section - Commented */}
        {/*
        <Grid container spacing={3} mt={5}>
          <Grid item xs={12} md={4}>
            <AppWidgetSummary
              // link={PATH_DASHBOARD.alumni.list}
              title="Total Players"
              total={100}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <AppWidgetSummary
              // link={PATH_DASHBOARD.pages.list}
              title="Total Teams"
              total={100}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <AppWidgetSummary
              // link={`${PATH_DASHBOARD.news.list}?trip=upcoming`}
              title="No. of Tournament "
              total={100}
            />
          </Grid>
          <Grid item xs={12} md={12}>
          </Grid>
          */}

        {/* Welcome Page Section */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "calc(100vh - 64px)",
            textAlign: "center",
            // backgroundImage: `url("/assets/background/logo.png")`,
            backgroundSize: "contain",
            backgroundPosition: "center",
            borderRadius: "16px",
            color: "#ffffff",
            padding: "50px",
            overflow: "hidden",
            position: "relative",
          }}
        >
          {/* Overlay for darker effect */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 0,
            }}
          ></div>

          <Typography
            variant="h2"
            gutterBottom
            style={{
              fontWeight: 700,
              zIndex: 1,
              color: "#000",
            }}
          >
            Welcome to NKL Dashboard
          </Typography>
          <Typography
            variant="h6"
            style={{
              marginTop: "20px",
              maxWidth: "600px",
              zIndex: 1,
              color: "#000",
            }}
          >
            Manage players, teams, and matches effortlessly. Your all-in-one
            platform for organizing and tracking Kabaddi events.
          </Typography>
        </div>
      </Container>
    </>
  );
}
